import { createFileRoute } from '@tanstack/react-router'
import { OnboardingPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/onboarding')({
  head: () => noIndexRouteHead('onboarding', 'it'),
  component: OnboardingPage,
})
